import React from "react";

export default function TwentyThree({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M149.59,227.51a8.53,8.53,0,0,1-6-2.49l-21.23-21.23a5.23,5.23,0,0,0-3.75-1.56H57.3a8.53,8.53,0,0,1-8.53-8.53V9.13A8.53,8.53,0,0,1,57.3.6H241.87a8.53,8.53,0,0,1,8.53,8.53V193.7a8.53,8.53,0,0,1-8.53,8.53H180.6a5.25,5.25,0,0,0-3.75,1.56L155.62,225A8.51,8.51,0,0,1,149.59,227.51ZM57.3,3.83A5.3,5.3,0,0,0,52,9.13V193.7a5.31,5.31,0,0,0,5.3,5.3h61.27a8.47,8.47,0,0,1,6,2.5l21.24,21.23a5.31,5.31,0,0,0,7.5,0l21.23-21.23a8.47,8.47,0,0,1,6-2.5h61.27a5.3,5.3,0,0,0,5.3-5.3V9.13a5.3,5.3,0,0,0-5.3-5.3Z" />
      <path d="M242.25,238H58.63a9.18,9.18,0,0,0-9,9.37v42.11a9.18,9.18,0,0,0,9,9.38h183.7a9.13,9.13,0,0,0,8.9-9.38V247.36A9.17,9.17,0,0,0,242.25,238Z" />
      {children}
    </svg>
  );
}
